import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import {
  getOrderOrganService,
  getOrdersOrganService,
} from "./../../../services/organService";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const orderOrganContext = createContext({
  orders: [],
  setOrders: () => {},
  order: {},
  setOrder: () => {},
  config: {},
  setConfig: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetOrders: () => {},
  handleGetOrder: () => {},
  handleResetState: () => {},
});

const OrderOrganContext = ({ children }) => {
  const appConfigs = useSelector((state) => state.appConfigs);

  // Redux Dispatch
  const dispatch = useDispatch();

  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState({});
  const [config, setConfig] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);

  useEffect(() => {
    handleGetAppConfig();
  }, [appConfigs]);

  // Handle Get App Configs Method
  const handleGetAppConfig = async () => {
    if (appConfigs) {
      const cleanConfig = {};
      cleanConfig.STATUS_CHOICES = appConfigs.STATUS_CHOICES?.split("،");
      cleanConfig.STATUS_CHOICES_USER =
        appConfigs.STATUS_CHOICES_USER?.split("،");
      cleanConfig.PAYMENT_TYPE = appConfigs.PAYMENT_TYPE?.split("،");
      cleanConfig.CITY_CHOICES = appConfigs.CITY_CHOICES?.split("،");
      setConfig({ ...appConfigs, ...cleanConfig });
    }
  };

  const handleResetState = () => {
    setOrder({});
  };

  // Details Order Modal Operations
  const handleShowDetailsModal = () => {
    setIsShowDetailsModal(true);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    handleResetState();
  };

  // Handle Get Orders Method
  const handleGetOrders = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getOrdersOrganService(objData);
      if (status === 200) {
        setOrders(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Order Method
  const handleGetOrder = async (pk, func) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getOrderOrganService(pk);
      if (status === 200) {
        setOrder(data);

        // Handle Custom Function
        if (func) {
          func();
        }
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <orderOrganContext.Provider
      value={{
        orders,
        setOrders,
        order,
        setOrder,
        config,
        setConfig,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleGetOrders,
        handleGetOrder,
        handleResetState,
      }}
    >
      {children}
    </orderOrganContext.Provider>
  );
};

export default OrderOrganContext;
